import { HStack, Box, SimpleGrid } from '@chakra-ui/react';
import { Skeleton } from '@/components/ui/skeleton';

export function AgentItemSkeleton() {
  return (
    <HStack
      flexDirection={'column'}
      padding={'12px'}
      gap={'8px'}
      borderRadius={'12px'}
      border={'1px solid rgba(255, 255, 255, 0.1)'}
      className="agent-item-skeleton"
      mb={2}
    >
      {/* 最大收益率标签部分 */}
      <HStack
        flexDirection={'row'}
        alignItems={'center'}
        position={'relative'}
        w={'100%'}
      >
        <HStack
          position={'absolute'}
          right={0}
          top={0}
          gap={0}
          flexDirection={'row'}
          alignItems={'center'}
          zIndex={9}
        >
          <HStack
            padding={'0 21px 0 7px'}
            h={'28px'}
            background={'rgba(171, 234, 69, 0.1)'}
            borderRadius={'10px 0 0 0'}
            marginRight={'-16px'}
          >
            <Skeleton h="12px" w="60px" />
          </HStack>
          <HStack
            background={'rgba(171, 234, 69, 0.2)'}
            pl={'5px'}
            pr={'5px'}
            height={'32px'}
            borderRadius={'10px 0 10px 0'}
            alignItems={'center'}
            justifyContent={'center'}
            flexDirection={'row'}
            zIndex={8}
          >
            <Skeleton h="14px" w="30px" />
          </HStack>
        </HStack>
      </HStack>

      {/* 代币信息部分 */}
      <HStack flexDirection={'column'} w={'100%'}>
        <Box w={'100%'}>
          <HStack flexDirection={'row'} className="flex-row items-center gap-1">
            <Skeleton w="32px" h="32px" borderRadius="full" />
            <HStack
              flexDirection={'column'}
              alignItems={'flex-start'}
              justifyContent={'center'}
              gap={'2px'}
            >
              <Skeleton h="20px" w="80px" />
              <HStack
                className="flex-row items-center gap-1"
                w={'100%'}
                alignItems={'center'}
              >
                <Skeleton h="12px" w="40px" />
                <Skeleton h="12px" w="80px" />
                <Skeleton h="12px" w="14px" />
              </HStack>
            </HStack>
          </HStack>
        </Box>

        {/* AI叙述部分 */}
        <Box w={'100%'} mb={'8px'}>
          <Box p={'8px'} mb={'8px'}>
            <HStack
              fontSize={'12px'}
              gap={0}
              flexWrap={'wrap'}
              flexDirection={'row'}
              position={'relative'}
              h={'32px'}
              overflow={'hidden'}
            >
              <Skeleton h="16px" w="100%" />
              <HStack
                position={'absolute'}
                bottom={'0'}
                right={'0'}
                gap={'2px'}
                h={'16px'}
              >
                <Skeleton h="12px" w="30px" />
                <Skeleton h="14px" w="14px" borderRadius="full" />
              </HStack>
            </HStack>
          </Box>

          {/* 信号数据部分 */}
          <HStack
            w={'100%'}
            gap={'8px'}
            pb={'6px'}
            css={{ 'border-bottom': '1px dashed rgba(255,255,255,0.1)' }}
          >
            <Box
              w={'60px'}
              h={'30px'}
              css={{ 'border-right': '1px dashed rgba(255,255,255,0.1)' }}
            >
              <Skeleton h="11px" w="40px" mt="10px" />
            </Box>
            <HStack gap={'4px'} flex={1}>
              <HStack
                gap={0}
                flex={1}
                alignItems={'center'}
                flexDirection={'column'}
              >
                <Skeleton h="14px" w="30px" mb="2px" />
                <Skeleton h="14px" w="40px" />
              </HStack>
              <HStack
                gap={0}
                flex={1}
                alignItems={'center'}
                flexDirection={'column'}
              >
                <Skeleton h="14px" w="30px" mb="2px" />
                <Skeleton h="14px" w="40px" />
              </HStack>
              <HStack
                gap={0}
                flex={1}
                alignItems={'center'}
                flexDirection={'column'}
              >
                <Skeleton h="14px" w="30px" mb="2px" />
                <Skeleton h="14px" w="40px" />
              </HStack>
              <HStack
                gap={0}
                flex={1}
                alignItems={'center'}
                flexDirection={'column'}
              >
                <Skeleton h="14px" w="30px" mb="2px" />
                <Skeleton h="14px" w="40px" />
              </HStack>
            </HStack>
          </HStack>

          {/* 当前数据部分 */}
          <HStack gap={'8px'} w={'100%'} pt={'6px'}>
            <Box
              w={'60px'}
              h={'30px'}
              css={{ 'border-right': '1px dashed rgba(255,255,255,0.1)' }}
            >
              <Skeleton h="11px" w="40px" mt="10px" />
            </Box>
            <HStack gap={'4px'} flex={1}>
              <HStack
                gap={0}
                flex={1}
                alignItems={'center'}
                flexDirection={'column'}
              >
                <Skeleton h="14px" w="30px" mb="2px" />
                <Skeleton h="14px" w="40px" />
              </HStack>
              <HStack
                gap={0}
                flex={1}
                alignItems={'center'}
                flexDirection={'column'}
              >
                <Skeleton h="14px" w="30px" mb="2px" />
                <Skeleton h="14px" w="40px" />
              </HStack>
              <HStack
                gap={0}
                flex={1}
                alignItems={'center'}
                flexDirection={'column'}
              >
                <Skeleton h="14px" w="30px" mb="2px" />
                <Skeleton h="14px" w="40px" />
              </HStack>
              <HStack
                gap={0}
                flex={1}
                alignItems={'center'}
                flexDirection={'column'}
              >
                <Skeleton h="14px" w="30px" mb="2px" />
                <Skeleton h="14px" w="40px" />
              </HStack>
            </HStack>
          </HStack>
        </Box>

        {/* 快速购买按钮部分 */}
        <SimpleGrid
          w="100%"
          gridTemplateColumns={'repeat(3, 1fr)'}
          gap={'8px 8px'}
          mt={2}
        >
          <Skeleton h="32px" borderRadius="md" />
          <Skeleton h="32px" borderRadius="md" />
          <Skeleton h="32px" borderRadius="md" />
          <Skeleton h="32px" borderRadius="md" />
          <Skeleton h="32px" borderRadius="md" />
          <Skeleton h="32px" borderRadius="md" />
        </SimpleGrid>
      </HStack>
    </HStack>
  );
}
